import { Box, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { Text } from "@src/appV2/redesign/components/Text";
import { type AccountSwitcherUser, type UserDetails } from "../../Shared/AccountSwitcher/types";
import { AccountSwitcherOptionGroupDesktop } from "./AccountSwitcherOptionGroup";

interface AccountSwitcherDropdownAdminDesktopProps {
  workerDetails: UserDetails;
  workplaceDetails: UserDetails;
  onUserClicked: (user: AccountSwitcherUser) => void;
  onAdminClicked: () => void;
}

export function AccountSwitcherDropdownAdminDesktop(
  props: AccountSwitcherDropdownAdminDesktopProps
) {
  const { workerDetails, workplaceDetails, onUserClicked, onAdminClicked } = props;

  return (
    <>
      <Stack padding={2}>
        <Button fullWidth variant="outlineInverted" onClick={onAdminClicked}>
          Switch To Administrator
        </Button>
      </Stack>
      <Box>
        <Box data-testid="account-switcher-agents" sx={{ marginBottom: 3 }}>
          <Text
            variant="body1"
            sx={(theme) => ({
              color: theme.palette.navbar?.sectionTitle,
            })}
          >
            AGENTS
          </Text>
          <Box>
            <AccountSwitcherOptionGroupDesktop
              userDetails={workerDetails}
              onUserClicked={onUserClicked}
            />
          </Box>
        </Box>
        <Box>
          <Text
            variant="body1"
            sx={(theme) => ({
              color: theme.palette.navbar?.sectionTitle,
            })}
          >
            WORKPLACES
          </Text>
          <Box>
            <AccountSwitcherOptionGroupDesktop
              userDetails={workplaceDetails}
              onUserClicked={onUserClicked}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
}
